import React, { useState } from 'react';
import { trackClick } from 'utility/analytics';
import { get, filter, map, startCase, pick } from 'lodash';
import { Link } from 'react-router-dom';
import { Row, Col } from '@zendeskgarden/react-grid';
import { Button } from 'theme/Button';
// import Icon from 'components/Icon/Icon';
import { MD, SM } from '@zendeskgarden/react-typography';
import ImageGallery from 'components/ImageGallery/ImageGallery';
import { Wrapper } from './ProductStyles.styles.js';
import { variables } from 'theme/variables';
const { media_md } = variables;

function generateAttributes(data = {}) {
  const attributes = pick(data, [
    'quantity',
    'manufactor',
    'mill_year',
    'condition_name',
  ]);
  if (data.attributes.mill_year) {
    attributes.mill_year = data.attributes.mill_year;
  }
  if (data.attributes.manufacturer) {
    attributes.manufacturer = data.attributes.manufacturer;
  }

  return filter(
    map(attributes, (value, key) => {
      const formatted =
        key === 'quantity' || key === 'price'
          ? `${value} ${data.quantity_uom_name}`
          : value;
      return {
        title: startCase(key.replace('_name', '')),
        value: formatted,
      };
    }),
    ({ value }) => !!value
  );
}

function onClickViewProduct(listing) {
  trackClick('viewListing', 'View Listing', 'ContentPage', {
    id: listing.id,
    title: listing.title,
  });
  window.open(`/l/${listing.slug}/${listing.id}`);
}

const ContentListing = ({ listing = {} } = {}) => {
  const attributes = generateAttributes(listing);
  return (
    <Wrapper>
      <Row wrap="wrap">
        <Col size="auto" extraPaddingRight={media_md}>
          <ImageGallery images={listing.images} />
        </Col>
        <Col className="content-wrapper-product">
          <div className="title">
            <Link target="_blank" to={`/l/${listing.slug}/${listing.id}`}>
              <MD className="bold" as="h3">
                {listing.title}
              </MD>
            </Link>
            <HeroAttributes
              location={listing.location_description}
              description={listing.description}
              attributes={attributes}
            />
            <Button
              style={{ display: 'block', marginTop: '30px' }}
              primary
              onClick={() => onClickViewProduct(listing)}
            >
              View Listing
            </Button>
          </div>
        </Col>
      </Row>
    </Wrapper>
  );
};

const HeroAttributes = ({ description = '', attributes, location } = {}) => {
  const defaultClamp = 124;
  const [clamp, setClamp] = useState(defaultClamp);
  const isClamp = get(description, 'length', 0) > clamp;
  const descriptionTrunc = isClamp
    ? `${description.substring(0, clamp)}...`
    : description;

  return (
    <div>
      <div className="attribute-description">
        <SM
          grey
          style={{ fontSize: '14px', lineHeight: '24px' }}
          noMargin
          as="h3"
        >
          {descriptionTrunc}{' '}
          {get(description, 'length', 0) <= defaultClamp ? null : isClamp ? (
            <SM
              grey
              onClick={() => setClamp(1000000)}
              style={{ fontSize: '14px', lineHeight: '24px' }}
              noMargin
              as="span"
              link
            >
              Read More
            </SM>
          ) : (
            <SM
              grey
              onClick={() => setClamp(defaultClamp)}
              style={{ fontSize: '14px' }}
              noMargin
              as="span"
              link
            >
              Read Less
            </SM>
          )}
        </SM>
      </div>
      <div>
        {map(attributes, (attribute, i) => {
          return (
            <div key={i}>
              <SM
                style={{ lineHeight: '26px', fontSize: '14px' }}
                noMargin
                as="h3"
                bold
              >
                <span className="bold">{attribute.title}:</span>{' '}
                {attribute.value}
              </SM>
            </div>
          );
        })}
      </div>
      {location ? (
        <div>
          <SM
            style={{ lineHeight: '26px', fontSize: '14px' }}
            noMargin
            as="h3"
            bold
          >
            <span className="bold">Location:</span> {location}
          </SM>
        </div>
      ) : null}
    </div>
  );
};

export default ContentListing;
